/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-07-08 11:46:50
 * @LastEditTime: 2025-07-08 11:49:59
 * @Description: 
 */
// src/components/Banner.jsx
import React from 'react';
import '../css/Banner.css';
import bannerImage from '../assets/banner.jpg'; // Place your banner image in src/assets/

const Banner = () => {
  return (
    <section className="banner">
      <div className="banner-track">
        <img src={bannerImage} alt="IT Solutions" className="banner-image" />
        <img src={bannerImage} alt="IT Solutions" className="banner-image" />
      </div>
            <div className="banner-text-m">
        <h1 className="company-name">GLOBAL TP TECHNOLOGY</h1>
        <p className="tagline">Expert in Apps & Software Development</p>
      </div>
    </section>
  );
};

export default Banner;
